import React from 'react';
import {
  EditOutlined as EditOutlinedIcon,
  DeleteOutlineOutlined as DeleteOutlineOutlinedIcon,
  PrintOutlined as PrintOutlinedIcon,
} from '@material-ui/icons';
import { CHECKOUT_STATUS, getCheckoutStatusIdByCode } from './CheckoutrequestPage';

export const STATUS_COLOR_MAP = {
  [CHECKOUT_STATUS.PENDING.value]: CHECKOUT_STATUS.PENDING.color,
  [CHECKOUT_STATUS.REVIEWED.value]: CHECKOUT_STATUS.REVIEWED.color,
  [CHECKOUT_STATUS.READY.value]: CHECKOUT_STATUS.READY.color,
  [CHECKOUT_STATUS.COMPLETE.value]: CHECKOUT_STATUS.COMPLETE.color,
  [CHECKOUT_STATUS.CANCEL.value]: CHECKOUT_STATUS.CANCEL.color,
};

export const getStatusColor = (statusCode) => STATUS_COLOR_MAP[statusCode] || 'default';

// Drives the colored dot + active-state tint on the checkout status strip, matching the same
// statStripBtn/statusDot pattern used by Evidence Records' StatStrip.
export const CHECKOUT_STATUS_CLASS_NAMES = {
  [CHECKOUT_STATUS.PENDING.value]: 'checkoutStatusPending',
  [CHECKOUT_STATUS.REVIEWED.value]: 'checkoutStatusReviewed',
  [CHECKOUT_STATUS.READY.value]: 'checkoutStatusReady',
  [CHECKOUT_STATUS.COMPLETE.value]: 'checkoutStatusComplete',
  [CHECKOUT_STATUS.CANCEL.value]: 'checkoutStatusCancel',
};

export const getHeaderActions = (request, onEdit, onDelete, onPrint) => {
  const status = request.StatusDetails?.Code;

  switch (status) {
    case CHECKOUT_STATUS.PENDING.value:
    case CHECKOUT_STATUS.REVIEWED.value:
    case CHECKOUT_STATUS.READY.value:
      return [
        onEdit && {
          icon: <EditOutlinedIcon fontSize="small" />,
          tooltip: 'Edit',
          onClick: () => onEdit(request),
        },
        onDelete && {
          icon: <DeleteOutlineOutlinedIcon fontSize="small" />,
          className: 'checkout-error-icon',
          tooltip: 'Delete',
          onClick: () => onDelete(request),
        },
        onPrint && {
          icon: <PrintOutlinedIcon fontSize="small" />,
          tooltip: 'Print',
          onClick: () => onPrint(request),
        },
      ].filter(Boolean);

    case CHECKOUT_STATUS.COMPLETE.value:
      return [
        onPrint && {
          icon: <PrintOutlinedIcon fontSize="small" />,
          tooltip: 'Print',
          onClick: () => onPrint(request),
        },
      ].filter(Boolean);

    case CHECKOUT_STATUS.CANCEL.value:
      return [
        onDelete && {
          icon: <DeleteOutlineOutlinedIcon fontSize="small" />,
          tooltip: 'Delete',
          className: 'checkout-error-icon',
          onClick: () => onDelete(request),
        },
        onPrint && {
          icon: <PrintOutlinedIcon fontSize="small" />,
          tooltip: 'Print', 
          onClick: () => onPrint(request),
        },
      ].filter(Boolean);

    default:
      return [];
  }
};

// checkoutStatuses is the getRefValues(Category='CheckOutRequest') list ({label, value, code}) —
// the real numeric Id for the next status is resolved from it via getCheckoutStatusIdByCode,
// never hardcoded, since codeRepValues Ids are environment-specific.
export const getFooterActions = (request, onStatusUpdate, checkoutStatuses) => {
  if (!onStatusUpdate) return [];
  const status = request.StatusDetails?.Code;
  const nextStatusId = (code) => getCheckoutStatusIdByCode(checkoutStatuses, code);

  switch (status) {
    case CHECKOUT_STATUS.PENDING.value:
      return [
        {
          label: 'Mark Reviewed',
          color: 'secondary',
          onClick: () => onStatusUpdate(request, nextStatusId(CHECKOUT_STATUS.REVIEWED.value)),
        },
        {
          label: 'Cancel',
          color: 'default',
          onClick: () => onStatusUpdate(request, nextStatusId(CHECKOUT_STATUS.CANCEL.value)),
        },
      ];

    case CHECKOUT_STATUS.REVIEWED.value:
      return [
        {
          label: 'Mark Ready',
          color: 'info',
          onClick: () => onStatusUpdate(request, nextStatusId(CHECKOUT_STATUS.READY.value)),
        },
        {
          label: 'Cancel',
          color: 'default',
          onClick: () => onStatusUpdate(request, nextStatusId(CHECKOUT_STATUS.CANCEL.value)),
        },
      ];

    case CHECKOUT_STATUS.READY.value:
      return [
        {
          label: 'Complete',
          color: 'primary',
          onClick: () => onStatusUpdate(request, nextStatusId(CHECKOUT_STATUS.COMPLETE.value)),
        },
        {
          label: 'Cancel',
          color: 'default',
          onClick: () => onStatusUpdate(request, nextStatusId(CHECKOUT_STATUS.CANCEL.value)),
        },
      ];

    default:
      return [];
  }
};
